(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cf-reasons-v2')) return;

    class CordaFitReasons extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.abort) return;
        this.track = this.querySelector('[data-cf4-track]');
        if (!this.track) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.cards = [...this.querySelectorAll('[data-cf4-card]')];
        this.previous = this.querySelector('[data-cf4-prev]');
        this.next = this.querySelector('[data-cf4-next]');
        this.status = this.querySelector('[data-cf4-status]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.media = [];
        const navigation = this.querySelector('[data-cf4-navigation]');
        if (navigation) navigation.hidden = false;

        this.previous?.addEventListener('click', () => this.step(-1), { signal });
        this.next?.addEventListener('click', () => this.step(1), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const key = event.key;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
          event.preventDefault();
          if (key === 'Home') this.move(0);
          else if (key === 'End') this.move(this.maximum());
          else this.step(key === 'ArrowRight' ? 1 : -1);
        }, { signal });

        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.maximum() < 2) return;
          if (event.target.closest('button, a, video, input, textarea, select')) return;
          this.drag = { id: event.pointerId, startX: event.clientX, startScroll: this.track.scrollLeft, moved: false };
        }, { signal });
        this.track.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const distance = event.clientX - this.drag.startX;
          if (!this.drag.moved && Math.abs(distance) < 6) return;
          if (!this.drag.moved) {
            this.drag.moved = true;
            this.track.dataset.dragging = 'true';
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = this.drag.startScroll - distance;
        }, { signal });
        const endDrag = () => {
          if (!this.drag) return;
          const moved = this.drag.moved;
          const point = this.nearest();
          this.drag = null;
          delete this.track.dataset.dragging;
          if (moved) this.move(point);
        };
        this.track.addEventListener('pointerup', endDrag, { signal });
        this.track.addEventListener('pointercancel', endDrag, { signal });
        this.track.addEventListener('lostpointercapture', endDrag, { signal });
        window.addEventListener('pointerup', endDrag, { signal });

        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.cards.forEach(card => this.resize.observe(card));
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) this.move(this.position(card), true);
        }, { signal });

        this.setupVideos(signal);
        this.update();
      }

      maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }

      position(card) {
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - padding;
        return Math.max(0, Math.min(left, this.maximum()));
      }

      points() { return [...new Set(this.cards.map(card => Math.round(this.position(card))))]; }

      nearest() {
        const points = this.points();
        return points.reduce((best, point) => Math.abs(point - this.track.scrollLeft) < Math.abs(best - this.track.scrollLeft) ? point : best, 0);
      }

      step(direction) {
        const current = this.track.scrollLeft;
        const points = this.points();
        const target = direction > 0
          ? points.find(point => point > current + 3) ?? this.maximum()
          : [...points].reverse().find(point => point < current - 3) ?? 0;
        this.move(target);
      }

      move(left, immediate = false) {
        this.track.scrollTo({ left, behavior: immediate || this.reduced.matches ? 'instant' : 'smooth' });
      }

      update() {
        const maximum = this.maximum();
        const current = this.track.scrollLeft;
        this.dataset.overflow = String(maximum > 2);
        if (this.previous) this.previous.disabled = current <= 2;
        if (this.next) this.next.disabled = current >= maximum - 2;
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => {
          if (!this.status) return;
          const points = this.points();
          const index = points.indexOf(this.nearest()) + 1;
          this.status.textContent = maximum <= 2
            ? `${this.cards.length} cartes affichées`
            : `Carte ${index} sur ${this.cards.length}`;
        }, 180);
      }

      setupVideos(signal) {
        this.querySelectorAll('[data-cf4-video]').forEach(video => {
          const toggle = video.parentElement.querySelector('[data-cf4-toggle]');
          if (!toggle) return;
          const state = { video, toggle, visible: false, userPaused: false, manual: false, pending: false };
          this.media.push(state);
          video.controls = false;
          video.muted = true;
          toggle.hidden = false;
          const label = video.getAttribute('aria-label') || 'CordaFit';
          const sync = () => {
            const playing = !video.paused && !video.ended;
            toggle.dataset.playing = String(playing);
            toggle.setAttribute('aria-label', `${playing ? 'Mettre en pause' : 'Lire'} la vidéo : ${label}`);
          };
          video.addEventListener('play', sync, { signal });
          video.addEventListener('pause', sync, { signal });
          video.addEventListener('ended', sync, { signal });
          video.addEventListener('error', () => { video.controls = true; toggle.hidden = true; }, { signal });
          toggle.addEventListener('click', () => {
            if (!video.paused || state.pending) {
              state.userPaused = true;
              state.manual = false;
              video.pause();
            } else {
              state.userPaused = false;
              state.manual = true;
              state.visible = true;
              this.syncVideo(state);
            }
          }, { signal });
          sync();
        });

        if ('IntersectionObserver' in window) {
          this.intersection = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const state = this.media.find(item => item.video === entry.target);
              if (!state) return;
              state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.55;
              this.syncVideo(state);
            });
          }, { threshold: [0, 0.55] });
          this.media.forEach(state => this.intersection.observe(state.video));
        }
        document.addEventListener('visibilitychange', () => this.media.forEach(state => this.syncVideo(state)), { signal });
        this.reduced.addEventListener('change', () => this.media.forEach(state => this.syncVideo(state)), { signal });
      }

      shouldPlay(state) {
        const automatic = this.dataset.autoplay === 'true' && !this.reduced.matches;
        return this.isConnected && !document.hidden && state.visible && !state.userPaused && (state.manual || automatic);
      }

      syncVideo(state) {
        if (!this.shouldPlay(state)) { state.video.pause(); return; }
        if (!state.video.paused || state.pending) return;
        state.pending = true;
        state.video.play().catch(() => {
          /* Économie d'énergie / lecture automatique bloquée : le bouton reste disponible. */
        }).finally(() => {
          state.pending = false;
          if (!this.shouldPlay(state)) state.video.pause();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.statusTimer);
        this.abort?.abort();
        this.abort = null;
        this.resize?.disconnect();
        this.intersection?.disconnect();
        this.media?.forEach(state => state.video.pause());
        this.drag = null;
        if (this.track) delete this.track.dataset.dragging;
      }
    }

    customElements.define('cf-reasons-v2', CordaFitReasons);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samedi"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tag = 'cordafit-energy-v1';
    if (!('customElements' in window) || customElements.get(tag)) return;

    class CordaFitEnergy extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-cf-ready]')) this.boot();
        else {
          this.waiter = new MutationObserver(() => {
            if (!this.querySelector('[data-cf-ready]')) return;
            this.waiter.disconnect();
            this.boot();
          });
          this.waiter.observe(this, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() { this.destroy(); }

      boot() {
        if (this.initialized || !this.isConnected) return;
        this.tabs = [...this.querySelectorAll('[data-cf-tab]')];
        if (!this.tabs.length) return;
        this.initialized = true;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.format = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
        this.durationFormat = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
        this.duration = Math.min(1200, Math.max(200, Number(this.dataset.duration) || 700));
        this.indicator = this.querySelector('[data-cf-indicator]');
        this.panel = this.querySelector('[data-cf-panel]');
        this.total = this.querySelector('[data-cf-total]');
        this.bars = [...this.querySelectorAll('[data-cf-bar]')];
        this.values = [...this.querySelectorAll('[data-cf-value]')];
        this.maxLabel = this.querySelector('[data-cf-max]');
        this.halfLabel = this.querySelector('[data-cf-half]');
        this.ring = this.querySelector('[data-cf-ring]');
        this.dial = this.querySelector('[data-cf-dial]');
        this.minutes = this.querySelector('[data-cf-minutes]');
        this.selectedLabel = this.querySelector('[data-cf-selected-label]');
        this.status = this.querySelector('[data-cf-status]');
        this.data = this.tabs.map(tab => {
          let values;
          try { values = JSON.parse(tab.dataset.values); } catch (_) { values = []; }
          values = Array.from({ length: 6 }, (_, i) => Number.isFinite(Number(values[i])) ? Math.max(0, Number(values[i])) : 0);
          const label = tab.dataset.label || tab.textContent.trim();
          const match = label.match(/^(\d+(?:[.,]\d+)?)\s*(?:min(?:ute)?s?)?$/i);
          return { values, label, minutes: match ? Number(match[1].replace(',', '.')) : null };
        });
        this.longest = Math.max(60, ...this.data.map(item => item.minutes || 0));
        this.fixedMax = Math.max(1, Number(this.dataset.chartMax) || 1000, ...this.data.flatMap(item => item.values));
        this.index = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
        const initial = this.data[this.index];
        this.snapshot = { values: [...initial.values], max: this.scale(initial.values), minutes: initial.minutes || 0 };
        this.panel.setAttribute('role', 'tabpanel');
        this.panel.tabIndex = 0;
        this.querySelector('[data-cf-controls]').hidden = false;
        this.select(this.index, false, false);

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i), { signal });
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = null;
            if (event.key === 'ArrowRight') next = (i + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (i + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === null) return;
            event.preventDefault();
            this.tabs[next].focus({ preventScroll: true });
            this.select(next);
          }, { signal });
        });

        this.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.dataset.blockId === String(event.detail?.blockId));
          if (index >= 0) this.select(index, false, false);
        }, { signal });
        this.motionChanged = () => { if (this.motion.matches) this.select(this.index, false, false); };
        if (this.motion.addEventListener) this.motion.addEventListener('change', this.motionChanged);
        else this.motion.addListener(this.motionChanged);
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.placeIndicator());
          this.resize.observe(this.querySelector('[data-cf-tabs]'));
        } else window.addEventListener('resize', () => this.placeIndicator(), { signal });
        this.readyFrame = requestAnimationFrame(() => this.classList.add('is-ready'));
      }

      scale(values) {
        const peak = Math.max(0, ...values);
        if (this.dataset.scaleMode === 'fixed') return this.fixedMax;
        if (!peak) return 100;
        const base = Math.pow(10, Math.ceil(Math.log10(peak)) - 1);
        return base * ([1, 2, 3, 5, 10].find(step => base * step >= peak) || 10);
      }

      placeIndicator() {
        const tab = this.tabs?.[this.index];
        if (!tab || !this.indicator) return;
        this.indicator.style.width = `${tab.offsetWidth}px`;
        this.indicator.style.height = `${tab.offsetHeight}px`;
        this.indicator.style.transform = `translate3d(${tab.offsetLeft}px, ${tab.offsetTop}px, 0)`;
      }

      select(index, animate = true, announce = true) {
        if (!this.initialized || !this.data[index]) return;
        const same = this.index === index;
        this.index = index;
        const target = this.data[index];
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panel.setAttribute('aria-labelledby', this.tabs[index].id);
        this.selectedLabel.textContent = target.label;
        this.dial.hidden = target.minutes === null;
        this.placeIndicator();
        if (same && animate) return;
        cancelAnimationFrame(this.frame);
        const from = { values: [...this.snapshot.values], max: this.snapshot.max, minutes: this.snapshot.minutes };
        const to = { values: [...target.values], max: this.scale(target.values), minutes: target.minutes || 0 };
        const finish = () => {
          this.paint(to);
          if (announce) this.status.textContent = `${target.label} : environ ${this.format.format(target.values[5])} kilocalories avec ${this.querySelector('.cfep__brand').textContent.trim()}.`;
        };
        if (!animate || this.motion.matches) { finish(); return; }
        const start = performance.now();
        const tick = now => {
          const p = Math.min(1, (now - start) / this.duration);
          const eased = 1 - Math.pow(1 - p, 4);
          this.paint({
            values: from.values.map((v, i) => v + (to.values[i] - v) * eased),
            max: from.max + (to.max - from.max) * eased,
            minutes: from.minutes + (to.minutes - from.minutes) * eased
          });
          if (p < 1) this.frame = requestAnimationFrame(tick);
          else finish();
        };
        this.frame = requestAnimationFrame(tick);
      }

      paint(state) {
        this.snapshot = state;
        this.total.textContent = this.format.format(state.values[5]);
        this.total.style.fontSize = state.values[5] >= 10000 ? 'clamp(30px, 5vw, 50px)' : '';
        this.values.forEach((value, i) => {
          value.textContent = this.format.format(state.values[i]);
          this.bars[i].style.transform = `scaleX(${Math.min(1, Math.max(0, state.values[i] / state.max))})`;
        });
        this.maxLabel.textContent = this.format.format(state.max);
        this.halfLabel.textContent = this.format.format(state.max / 2);
        this.minutes.textContent = this.durationFormat.format(state.minutes);
        this.ring.setAttribute('stroke-dashoffset', String(100 - Math.min(100, state.minutes / this.longest * 100)));
      }

      destroy() {
        this.waiter?.disconnect();
        this.resize?.disconnect();
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.readyFrame);
        if (this.motion && this.motionChanged) {
          if (this.motion.removeEventListener) this.motion.removeEventListener('change', this.motionChanged);
          else this.motion.removeListener(this.motionChanged);
        }
        this.classList.remove('is-ready');
        this.initialized = false;
      }
    }

    customElements.define(tag, CordaFitEnergy);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(tag).forEach(element => element.boot()));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(tag).forEach(element => element.destroy()));
  })();

  } catch(e) { console.error(e); }
})();
})();
